(function() {
  'use strict';
  angular.module('benefits')
  .filter('showInclusiveCodes', ['$filter', function($filter) {
    return function(procedureHistory, procedureCodeLookedUp, relatedProcedures) {
      let procHistory = [];
      let relatedCodes = [];
      if(relatedProcedures.length) {
        _.each(relatedProcedures, (procedure) => {
          relatedCodes.push(procedure.codes);
        });
        relatedCodes = _.union(_.flattenDeep(relatedCodes));
      }
      return _.filter(procedureHistory, (procedure) => {
         return (procedure.code === procedureCodeLookedUp) || _.find(relatedCodes, (code) => {
           return procedure.code === code;
         });
      });
    };
  }]);
})();
